module.exports = __webpack_public_path__ + "static/img/hnsjb.5920d2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/appModule/bouncedMormApp/img/hnsjb.jpg
// module id = MEZb
// module chunks = 1